import { ReviewedStatus } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/booking_submission.pb';
import { EventStatus } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/calendar_event.pb';
import { i18next } from '@frontend/i18n';
import { theme } from '@frontend/theme';

export const SCHEDULE_LOCAL_STORAGE_KEYS = {
  SCHEDULE_PULSE_STORE: 'schedule-pulse-store',
  SCHEDULE_CALENDAR_STORE: 'schedule-calendar-store',
  SCHEDULE_CALENDAR_LOCATION_STORE: 'schedule-calendar-location-store',
};

export const MIN_APPT_TYPE_DURATION_IN_MINUTES = 15;

export const MINUTE_IN_MILLISECONDS = 60 * 1000;

export const DEFAULT_ZOOM_LEVEL = 2;

export const DATETIME_FORMATS = {
  US_DATE_LONG: 'MMMM D, YYYY', // January 1, 2023
  US_DATE: 'MM/DD/YYYY', // 12/31/2022
  ISO_DATE: 'YYYY-MM-DD', // 2025-06-13
  US_DATE_TIME: 'MM/DD/YYYY HH:mm:ss', // 12/31/2022 14:30:00
  ISO_TIME: 'HH:mm:ss', // 14:30:00
  US_TIME: 'HH:mm',
  ISO_DATETIME: 'YYYY-MM-DDTHH:mm:ss', // 2025-06-13T14:30:00
  ISO_DATETIME_WITH_MILLISECONDS: 'YYYY-MM-DDTHH:mm:ss.sss', // 2025-06-13T14:30:00.123
  ISO_DATETIME_WITH_MILLISECONDS_UTC: 'YYYY-MM-DDTHH:mm:ss.sss[Z]', // 2025-06-13T14:30:00.123Z
  ISO_DATETIME_WITH_OFFSET: 'YYYY-MM-DDTHH:mm:ssZ', // 2025-06-13T14:30:00-05:00
};

export const WEAVE_HELP_URLS = {
  INSTALL_TEXT_CONNECT: 'https://www.weavehelp.com/weavehelp/article/install-and-use-text-connect',
  ADD_ONLINE_SCHEDULING_LINK:
    'https://www.weavehelp.com/hc/en-us/articles/4414683486875-Add-the-Online-Scheduling-Link-to-Your-Website',
  CONTACT_WEAVE_SUPPORT: 'https://www.weavehelp.com/weavehelp/contact-us',
  SCHEDULE_SETTINGS_NON_INTEGRATED: 'https://www.weavehelp.com/weavehelp/article/schedule-settings-non-integrated',
  SCHEDULE_SETTINGS_INTEGRATED:
    'https://www.weavehelp.com/weavehelp/article/schedule-settings-set-up-providers-services-and-availability-integrated',
};

export const WEAVE_PRIVACY_POLICY_URL = 'https://getweave.com/legal/privacy';

export const LOCAL_STORAGE_KEYS = {
  TIMEZONE_BANNER_DISMISSED: 'weave.schedule-timezone-banner-dismissed',
};

export const scheduleDirectAvailabilityBannerText = {
  officeHoursDirectAvailabilityTitle: i18next.t('Now managing availability through your PMS', {
    ns: 'schedule',
  }),
  officeHoursDirectAvailabilityMessage: i18next.t(
    'Availability for Weave Online Scheduling is now based on your practice management system settings.',
    { ns: 'schedule' }
  ),
  providerScheduleDirectAvailabilityTitle: i18next.t('Now managing availability through your PMS', {
    ns: 'schedule',
  }),
  providerScheduleDirectAvailabilityMessage: i18next.t(
    'Provider availability for Weave Online Scheduling is now based on your practice management system settings.',
    { ns: 'schedule' }
  ),
};

// Calendar
export const MAX_CALENDAR_LOCATION_COUNT = 4;
export const DEFAULT_CALENDAR_SCROLL_TO_TIME = '07:00 AM';
export const DEFAULT_TIME_FIELD_SCROLL_TO_TIME = '07:00:00';
export const CALENDAR_SCROLL_TO_OFFSET_IN_MINUTES = 15;

// The default appointment type color represented by the left stripe of the appointment event card used throughout NWX
export const PRIMARY_EVENT_COLOR = theme.colors.warning20;

// The default appointment event background color used throughout NWX
export const EVENT_BACKGROUND_COLOR = theme.colors.white;

export const REQUEST_EVENT_BACKGROUND_COLOR = theme.colors.indigo10;

export const EVENT_BACKGROUND_COLOR_PALETTE = [
  EVENT_BACKGROUND_COLOR,
  theme.colors.warning10,
  theme.colors.tangerine10,
  theme.colors.critical10,
  theme.colors.rose10,
  theme.colors.neutral10,
  theme.colors.secondary.seaweed10,
  theme.colors.primary10,
  REQUEST_EVENT_BACKGROUND_COLOR,
  theme.colors.secondary.eggplant10,
];

export const DEFAULT_APPOINTMENT_STATUS = EventStatus.UNCONFIRMED;

// The default statuses param to fetch request list for Schedule Pulse and Dashboard lists
export const DEFAULT_SCHEDULE_REQUEST_STATUSES_PARAM_V2 = 'Pending, Messaged, Called';
export const DEFAULT_SCHEDULE_REQUEST_STATUSES_PARAM_V3 = [
  ReviewedStatus.PENDING,
  ReviewedStatus.MESSAGED,
  ReviewedStatus.CALLED,
];
